import { DeleteOutlined } from '@ant-design/icons';
import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Flex,
  Image,
  Space,
  Tag,
  Typography,
} from 'antd';
import React from 'react';
import { getBrandLogo } from '../../../../utils/fn/products';

const { Text } = Typography;

const SelectedProductsColumn = ({
  associatedProducts,
  removeAssociatedProduct,
}) => {
  return (
    <Col
      span={12}
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100vh - 250px)',
        minHeight: 300,
      }}
    >
      <Card
        size="small"
        title={
          <Flex align="center" justify="space-between">
            <Text strong>Produits sélectionnés</Text>
            <Tag color="blue">{associatedProducts.length}</Tag>
          </Flex>
        }
        styles={{
          body: {
            padding: 12,
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        {associatedProducts.length === 0 ? (
          <Empty description="Aucun produit sélectionné" />
        ) : (
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              paddingRight: 4,
            }}
          >
            <Flex vertical gap={12}>
              {associatedProducts.map((product) => (
                <Card
                  key={product.reference}
                  size="small"
                  hoverable
                  styles={{ body: { padding: 12 } }}
                >
                  <Flex gap={12} align="flex-start" justify="space-between">
                    <Avatar
                      shape="square"
                      size={64}
                      src={product.main_image}
                      alt={product.name}
                      style={{ flexShrink: 0 }}
                    />
                    <Flex vertical gap={4} style={{ flex: 1, minWidth: 0 }}>
                      <Text strong ellipsis={{ tooltip: product.name }}>
                        {product.name}
                      </Text>
                      <Space size={4} wrap>
                        <Tag color="blue">{product.category.name}</Tag>
                        {product.brand && (
                          <Image
                            src={getBrandLogo(product.brand)}
                            alt={product.brand}
                            preview={false}
                            height={10}
                            style={{ objectFit: 'contain' }}
                          />
                        )}
                      </Space>
                      {product.category && (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {product.reference}
                        </Text>
                      )}
                    </Flex>
                    <Button
                      size="small"
                      type="link"
                      danger
                      onClick={() => removeAssociatedProduct(product.reference)}
                      icon={<DeleteOutlined />}
                    />
                  </Flex>
                </Card>
              ))}
            </Flex>
          </div>
        )}
      </Card>
    </Col>
  );
};

export default SelectedProductsColumn;
